import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AddSurveyDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    addSurvey(authCode: string, userAccountId: number): Observable<any> {
        authCode = authCode.replace(/-/g, '');
        const addSurveyUrl = ecorEnv.apiEndpoint + '/secure/surveys/' + authCode + '/users/' + userAccountId;
        return this.httpClient.post<any>(addSurveyUrl, null)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('add-survey-dialog-http', 'error', error);
        if (typeof error.error !== 'undefined' && error.error instanceof ErrorEvent) {
            console.error('add-survey-dialog-http', 'client side error:', error.error);
        } else {
            return throwError(error);
        }
        return throwError('Error-222222');
    }
}
